import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from '@chakra-ui/react'
import { SlideImages } from '../SlideImages'
export function ModalSlideImages({ images }) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
      <Button onClick={onOpen} mx="auto">
        Ver imagens cadastradas
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} size="5xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Imagens</ModalHeader>
          <ModalCloseButton />
          <ModalBody display="flex" flexDir="column" w="100%" gap={4}>
            <Flex w="100%">
              <SlideImages images={images} />
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}
